"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

exports.default = mapValues;


//////////////////
// WEBPACK FOOTER
// ./node_modules/recompose/utils/mapValues.js
// module id = 1978
// module chunks = 0